define('TescoMobile_Checkout/js/validation-mixin',['underscore', 'jquery', 'mageUtils', 'moment', 'TescoMobile_Checkout/js/action/validate-password', 'jquery-ui-modules/widget', 'jquery/validate', 'mage/translate', 'mage/validation'], function (_, $, utils, moment, validatePasswordFunc) {
  'use strict';
  function validateCreditCard(s) {
    var v = '0123456789',
      w = '',
      i,
      j,
      k,
      m,
      c,
      a,
      x;
    for (i = 0; i < s.length; i++) {
      x = s.charAt(i);
      if (v.indexOf(x, 0) !== -1) {
        w += x;
      }
    }
    j = w.length / 2;
    k = Math.floor(j);
    m = Math.ceil(j) - k;
    c = 0;
    for (i = 0; i < k; i++) {
      a = w.charAt(i * 2 + m) * 2;
      c += a > 9 ? Math.floor(a / 10 + a % 10) : a;
    }
    for (i = 0; i < k + m; i++) {
      c += w.charAt(i * 2 + 1 - m) * 1;
    }
    return c % 10 === 0;
  }
  function getMoveInDate(groupSelector) {
    const month = groupSelector.find('[name*="[tm_start_date][month]"]').val(),
      year = groupSelector.find('[name*="[tm_start_date][year]"]').val();
    return {
      year: year,
      month: month
    };
  }
  function getBillingMoveInDate() {
    return getMoveInDate($('.billing_address .tm_start_date'));
  }
  function getPreviousAddressMoveInDate() {
    return getMoveInDate($('.previous_address .tm_start_date'));
  }
  function isDateValid(year, month) {
    return month && year && moment(year, 'YYYY', true).isValid() && moment(month, 'MM', true).isValid();
  }
  function isDateInFuture(year, month) {
    const now = moment(),
      startOfNextMonth = moment(now.format('YYYY') + '-' + now.format('MM'), 'YYYY-MM-DD').add(1, 'M').startOf("month"),
      date = moment(year + '-' + month, 'YYYY-MM-DD');
    return date.diff(startOfNextMonth, 'days') >= 0;
  }
  const emailValidator = function (value, element, config) {
    return $(config.selector).val().localeCompare(value) === 0;
  };
  const userNameValidator = function (value, element, config) {
    return !$(element).hasClass('username-taken');
  };
  const passwordValidator = function (value) {
    var _window$checkoutConfi;
    value = value ? value : $('#customer-password').val();
    var validator = this,
      _config = {},
      customerEmail = $('#customer-email').val();
    if (((_window$checkoutConfi = window.checkoutConfig) === null || _window$checkoutConfi === void 0 ? void 0 : _window$checkoutConfi.custom_password_validation) !== undefined) {
      _config = window.checkoutConfig.custom_password_validation;
    } else {
      _config = {
        "maximum_password_length": 15,
        "minimum_digits": 1,
        "minimum_lowercase": 1,
        "minimum_password_length": 8,
        "minimum_uppercase": 1,
        "maximum_consecutive_characters": 2
      };
    }
    validator.passwordErrorMessage = $.mage.__('Password invalid.');
    return !(validatePasswordFunc.passwordLength(value, _config.maximum_password_length, _config.minimum_password_length) || validatePasswordFunc.notUsername(value, customerEmail) || validatePasswordFunc.symbolsCheck(value, _config.minimum_lowercase, _config.minimum_uppercase, _config.minimum_digits) || validatePasswordFunc.consecutiveChars(value, _config.maximum_consecutive_characters) || validatePasswordFunc.consecutiveKeyboardChars(value, _config.maximum_consecutive_characters));
  };
  $.each({
    'validate-email-match': [emailValidator, $.mage.__('Emails does not match.')],
    'validate-user-name': [userNameValidator, $.mage.__('This email address already taken.')],
    'custom-password-validation': [passwordValidator, $.mage.__('Password invalid')]
  }, function (i, rule) {
    rule.unshift(i);
    $.validator.addMethod.apply($.validator, rule);
  });
  return function (rulesObject) {
    _.extend(rulesObject, _.mapObject({
      'validate-non-identity-with-billing': [function () {
        var groupPrevious = $('.previous_address .tm_start_date'),
          monthPrevious = groupPrevious.find('[name*="[tm_start_date][month]"]'),
          yeaPreviousr = groupPrevious.find('[name*="[tm_start_date][year]"]'),
          groupBilling = $('.billing_address .tm_start_date'),
          monthBilling = groupBilling.find('[name*="[tm_start_date][month]"]'),
          yearBilling = groupBilling.find('[name*="[tm_start_date][year]"]'),
          now = moment(),
          startDateBilling = moment(yearBilling.val() + '-' + monthBilling.val(), 'YYYY-MM-DD'),
          startDatePrevious = moment(yeaPreviousr.val() + '-' + monthPrevious.val(), 'YYYY-MM-DD');
        return startDateBilling > startDatePrevious || !yeaPreviousr.val() || !monthPrevious.val() || !yearBilling.val() || !monthBilling.val() || !moment(yeaPreviousr.val(), 'YYYY', true).isValid() || !moment(yearBilling.val(), 'YYYY', true).isValid() || !moment(monthPrevious.val(), 'MM', true).isValid() || !moment(monthBilling.val(), 'MM', true).isValid();
      }, $.mage.__('Previous date cannot be later than current date.')],
      'validate-holders-name': [function (value) {
        var format = /^[a-zA-Z\s]*$/;
        return format.test(value);
      }, $.mage.__('Invalid name format.')],
      'validate-month-format': [function (val) {
        return !val || moment(val, 'MM', true).isValid();
      }, $.mage.__('Please enter a date in the format MM/YYYY')],
      'validate-short-year-format': [function (val) {
        return !val || moment(val, 'YYYY', true).isValid();
      }, $.mage.__('Please enter a date in the format MM/YYYY')],
      'validate-names-with-double-barrelled': [function (value, element) {
        return !value || /^[a-z]+([ '`´‘’-][a-z]+)*$/i.test(value);
      }, $.mage.__('Letters, space, hyphen and apostrophe only')],
      'validate-surname-min-length': [function (value, element) {
        return !value || value.length > 1;
      }, $.mage.__('Please enter at least 2 characters.')],
      'validate-timeline-billing': [function () {
        const _getBillingMoveInDate = getBillingMoveInDate(),
          year = _getBillingMoveInDate.year,
          month = _getBillingMoveInDate.month;
        if (!isDateValid(year, month)) {
          return true;
        }
        return !isDateInFuture(year, month);
      }, $.mage.__('Date cannot be in the future.')],
      'validate-age-billing': [function () {
        var group = $('.billing_address .tm_start_date'),
          month = group.find('[name*="[tm_start_date][month]"]'),
          year = group.find('[name*="[tm_start_date][year]"]'),
          lastYear = moment().subtract(100, "years").unix(),
          dateValue = moment(year.val() + '-' + month.val() + '-' + '01', 'YYYY-MM-DD');
        return dateValue.unix() > lastYear || !month.val() || !year.val() || !moment(year.val(), 'YYYY', true).isValid() || !moment(month.val(), 'MM', true).isValid();
      }, $.mage.__('Date must not be more than 100 years old.')],
      'validate-age-previous': [function () {
        var group = $('.previous_address .tm_start_date'),
          month = group.find('[name*="[tm_start_date][month]"]'),
          year = group.find('[name*="[tm_start_date][year]"]'),
          lastYear = moment().subtract(100, "years").unix(),
          dateValue = moment(year.val() + '-' + month.val() + '-' + '01', 'YYYY-MM-DD');
        return dateValue.unix() > lastYear || !month.val() || !year.val() || !moment(year.val(), 'YYYY', true).isValid() || !moment(month.val(), 'MM', true).isValid();
      }, $.mage.__('Date must not be more than 100 years old.')],
      'validate-timeline-previous': [function () {
        const _getPreviousAddressMo = getPreviousAddressMoveInDate(),
          year = _getPreviousAddressMo.year,
          month = _getPreviousAddressMo.month;
        if (!isDateValid(year, month)) {
          return true;
        }
        return !isDateInFuture(year, month);
      }, $.mage.__('Date cannot be in the future.')],
      'validate-bill-preferred-notification': [function () {
        const value = $('input[name=tm_bill_preferred_notification]:checked').val();
        return undefined === value ? false : ['SMS', 'EMAIL'].includes(value);
      }, $.mage.__('This is a required field.')],
      'tm-clubcard-number': [function (value) {
        if (value) {
          return validateCreditCard(value);
        }
        return true;
      }, $.mage.__('Please enter a valid clubcard number.')],
      'tm-clubcard-number-length': [function (value) {
        var validator = this,
          _config = {
            "min_text_length": 16,
            "max_text_length": 18
          };
        if (![_config.min_text_length, _config.max_text_length].includes(value.length)) {
          if (value.length === 0) {
            return true;
          }
          validator.tmClubCardLengthErrorMessage = $.mage.__('This is %1 or %2 digits long.').replace('%1', _config.min_text_length).replace('%2', _config.max_text_length);
          return false;
        }
        return true;
      }, function () {
        return this.tmClubCardLengthErrorMessage;
      }],
      'tm-imei': [function (value) {
        var etal = /^[0-9]{15}$/;
        if (!etal.test(value)) {
          return false;
        }
        var sum = 0,
          mul = 2,
          l = 14;
        for (var i = 0; i < l; i++) {
          var digit = value.substring(l - i - 1, l - i);
          var tp = parseInt(digit, 10) * mul;
          if (tp >= 10) sum += tp % 10 + 1;else sum += tp;
          if (mul == 1) mul++;else mul--;
        }
        var chk = (10 - sum % 10) % 10;
        if (chk != parseInt(value.substring(14, 15), 10)) {
          return false;
        }
        return true;
      }, $.mage.__('This is not the correct device')],
      'validate-tm-day': [function (value) {
        return $.mage.isEmpty(value) || /^(0[1-9]|[12][0-9]|3[01])$/.test(value);
      }, $.mage.__('Please enter a valid date dd/mm/yyyy')],
      'validate-tm-month': [function (value) {
        return $.mage.isEmpty(value) || /^(0[1-9]|1[0-2])$/.test(value);
      }, $.mage.__('Please enter a valid date dd/mm/yyyy')],
      'validate-tm-year': [function (value) {
        return $.mage.isEmpty(value) || /\d{4}/.test(value);
      }, $.mage.__('Please enter a valid date dd/mm/yyyy')],
      'validate-tm-dob-format': [function (value, ruleParams) {
        const dobGroupElement = $(ruleParams.element),
          elDay = dobGroupElement.find('[name*="[day]"]'),
          elMonth = dobGroupElement.find('[name*="[month]"]'),
          elYear = dobGroupElement.find('[name*="[year]"]'),
          day = elDay.val(),
          month = elMonth.val(),
          year = elYear.val();
        if (!day || !month || !year) {
          return true;
        }
        return moment(`${year}-${month}-${day}`, 'YYYY-MM-DD', true).isValid();
      }, $.mage.__('Please enter a valid date dd/mm/yyyy')],
      'validate-dob-lifetime': [function (value, ruleParams) {
        var _dobGroupElement$find, _dobGroupElement$find2, _dobGroupElement$find3;
        const validator = this,
          lastYear = moment().subtract(ruleParams.maxYear, "years"),
          firstYear = moment().subtract(ruleParams.minYear, "years"),
          dobGroupElement = $(ruleParams.element),
          yearElement = dobGroupElement.find('[name*="[year]"]'),
          day = (_dobGroupElement$find = dobGroupElement.find('[name*="[day]"]')) === null || _dobGroupElement$find === void 0 ? void 0 : _dobGroupElement$find.val(),
          month = (_dobGroupElement$find2 = dobGroupElement.find('[name*="[month]"]')) === null || _dobGroupElement$find2 === void 0 ? void 0 : _dobGroupElement$find2.val(),
          year = (_dobGroupElement$find3 = dobGroupElement.find('[name*="[year]"]')) === null || _dobGroupElement$find3 === void 0 ? void 0 : _dobGroupElement$find3.val(),
          dob = moment(`${year}-${month}-${day}`, 'YYYY-MM-DD', true),
          elControl = yearElement.closest('.field'),
          message = $.mage.__('Age must be between {0} and {1}.');
        if (!day || !month || !year || dob.isValid() && dob.isBetween(lastYear.format('YYYY-MM-DD'), firstYear.format('YYYY-MM-DD'), null, '[]')) {
          return true;
        }
        validator.dobLifetimeErrorMessage = message.replace('{0}', ruleParams.minYear).replace('{1}', ruleParams.maxYear);
        return false;
      }, function () {
        return this.dobLifetimeErrorMessage;
      }]
    }, function (data) {
      return {
        handler: data[0],
        message: data[1]
      };
    }));
    return rulesObject;
  };
});

